import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeEsMx from '@angular/common/locales/es-MX';

// Import 3rd party components
import {
	PerfectScrollbarModule,
	PERFECT_SCROLLBAR_CONFIG,
	PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import {
	AppAsideModule,
	AppBreadcrumbModule,
	AppHeaderModule,
	AppFooterModule,
	AppSidebarModule,
} from '@coreui/angular';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';

import { NgxLoadingModule } from 'ngx-loading';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingModalComponent } from './shared/modal/loading-modal/loading-modal.component';

import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { RxReactiveDynamicFormsModule } from '@rxweb/reactive-dynamic-forms';

// Modules
import { SharedModule } from './shared/shared.module';
import { AdminModule } from './views/admin/admin.module';
import { AceEditorModule } from 'ng2-ace-editor';

// Import containers
import { DefaultLayoutComponent } from './containers';
// Default components
import { AppComponent } from './app.component';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

// Services
import { CatchAllInterceptorService } from './interceptors/catch-all-intercerptor.service';

// Import routing module
import { AppRoutingModule } from './app.routing';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { UtilsService } from './services/utils.service';
import { DragDropModule } from '@angular/cdk/drag-drop';

registerLocaleData(localeEs, 'es');

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};

const APP_CONTAINERS = [
	DefaultLayoutComponent
];

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		// Rx Web
		RxReactiveFormsModule,
		RxReactiveDynamicFormsModule,
		// 3rd party
		AppAsideModule,
		AppBreadcrumbModule.forRoot(),
		AppFooterModule,
		AppHeaderModule,
		AppSidebarModule,
		PerfectScrollbarModule,
		BsDropdownModule.forRoot(),
		BsDatepickerModule.forRoot(),
		ModalModule.forRoot(),
		TabsModule.forRoot(),
		ChartsModule,
		NgxLoadingModule.forRoot({}),
		LoadingBarHttpClientModule,
		LoadingBarRouterModule,
		LoadingBarModule,
		//
		AppRoutingModule,
		SharedModule,
		AdminModule,
		AceEditorModule,
		DragDropModule
	],
	declarations: [
		AppComponent,
		...APP_CONTAINERS,
		P404Component,
		P500Component,
		LoginComponent,
		RegisterComponent,

	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CatchAllInterceptorService,
			multi: true
		},
		{
			provide: LOCALE_ID,
			useValue: 'es-MX'
		},
		UtilsService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
